// extracted by mini-css-extract-plugin
export var container = "credits-module--container--8c7e1";
export var content = "credits-module--content--513df";
export var structuredText = "credits-module--structuredText--806ed";